"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TranslateEvent = void 0;

var _Collection = _interopRequireDefault(require("../Collection.js"));

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _Property = _interopRequireDefault(require("./Property.js"));

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _functions = require("../functions.js");

var _condition = require("../events/condition.js");

var _array = require("../array.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Translate
 */


/**
 * @enum {string}
 */
var TranslateEventType = {
  /**
   * Triggered upon feature translation start.
   * @event TranslateEvent#translatestart
   * @api
   */
  TRANSLATESTART: 'translatestart',

  /**
   * Triggered upon feature translation.
   * @event TranslateEvent#translating
   * @api
   */
  TRANSLATING: 'translating',

  /**
   * Triggered upon feature translation end.
   * @event TranslateEvent#translateend
   * @api
   */
  TRANSLATEEND: 'translateend'
};
/**
 * A function that takes an {@link module:ol/Feature~Feature} or
 * {@link module:ol/render/Feature~RenderFeature} and an
 * {@link module:ol/layer/Layer~Layer} and returns `true` if the feature may be
 * translated or `false` otherwise.
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>):boolean} FilterFunction
 */

/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.always}.
 * @property {Collection<import("../Feature.js").default>} [features] Features contained in this collection will be able to be translated together.
 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} [layers] A list of layers from which features should be
 * translated. Alternatively, a filter function can be provided. The
 * function will be called for each layer in the map and should return
 * `true` for layers that you want to be translatable. If the option is
 * absent, all visible layers will be considered translatable.
 * Not used if `features` is provided.
 * @property {FilterFunction} [filter] A function
 * that takes an {@link module:ol/Feature~Feature} and an
 * {@link module:ol/layer/Layer~Layer} and returns `true` if the feature may be
 * translated or `false` otherwise. Not used if `features` is provided.
 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside the radius around the given position
 * will be checked for features.
 */

/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Translate~Translate} instances
 * are instances of this type.
 */

var TranslateEvent =
/** @class */
function (_super) {
  __extends(TranslateEvent, _super);
  /**
   * @param {TranslateEventType} type Type.
   * @param {Collection<import("../Feature.js").default>} features The features translated.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../coordinate.js").Coordinate} startCoordinate The original coordinates before.translation started
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   */


  function TranslateEvent(type, features, coordinate, startCoordinate, mapBrowserEvent) {
    var _this = _super.call(this, type) || this;
    /**
     * The features being translated.
     * @type {Collection<import("../Feature.js").default>}
     * @api
     */


    _this.features = features;
    /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */

    _this.coordinate = coordinate;
    /**
     * The coordinate of the start position before translation started.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */

    _this.startCoordinate = startCoordinate;
    /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */

    _this.mapBrowserEvent = mapBrowserEvent;
    return _this;
  }

  return TranslateEvent;
}(_Event["default"]);

exports.TranslateEvent = TranslateEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'translateend'|'translatestart'|'translating', TranslateEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'translateend'|'translatestart'|'translating', Return>} TranslateOnSignature
 */

/**
 * @classdesc
 * Interaction for translating (moving) features.
 * If you want to translate multiple features in a single action (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.
 *
 * @fires TranslateEvent
 * @api
 */
var Translate =
/** @class */
function (_super) {
  __extends(Translate, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function Translate(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this,
    /** @type {import("./Pointer.js").Options} */
    options) || this;
    /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {TranslateOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {TranslateOnSignature<void>}
     */

    _this.un;
    /**
     * The last position we translated to.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.lastCoordinate_ = null;
    /**
     * The start position before translation started.
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */

    _this.startCoordinate_ = null;
    /**
     * @type {Collection<import("../Feature.js").default>|null}
     * @private
     */

    _this.features_ = options.features !== undefined ? options.features : null;
    /** @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} */

    var layerFilter;

    if (options.layers && !_this.features_) {
      if (typeof options.layers === 'function') {
        layerFilter = options.layers;
      } else {
        var layers_1 = options.layers;

        layerFilter = function layerFilter(layer) {
          return (0, _array.includes)(layers_1, layer);
        };
      }
    } else {
      layerFilter = _functions.TRUE;
    }
    /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean}
     */


    _this.layerFilter_ = layerFilter;
    /**
     * @private
     * @type {FilterFunction}
     */

    _this.filter_ = options.filter && !_this.features_ ? options.filter : _functions.TRUE;
    /**
     * @private
     * @type {number}
     */

    _this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.always;
    /**
     * @type {import("../Feature.js").default}
     * @private
     */

    _this.lastFeature_ = null;

    _this.addChangeListener(_Property["default"].ACTIVE, _this.handleActiveChanged_);

    return _this;
  }
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   */


  Translate.prototype.handleDownEvent = function (event) {
    if (!event.originalEvent || !this.condition_(event)) {
      return false;
    }

    this.lastFeature_ = this.featuresAtPixel_(event.pixel, event.map);

    if (!this.lastCoordinate_ && this.lastFeature_) {
      this.startCoordinate_ = event.coordinate;
      this.lastCoordinate_ = event.coordinate;
      this.handleMoveEvent(event);
      var features = this.features_ || new _Collection["default"]([this.lastFeature_]);
      this.dispatchEvent(new TranslateEvent(TranslateEventType.TRANSLATESTART, features, event.coordinate, this.startCoordinate_, event));
      return true;
    }

    return false;
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   */


  Translate.prototype.handleUpEvent = function (event) {
    if (this.lastCoordinate_) {
      this.lastCoordinate_ = null;
      this.handleMoveEvent(event);
      var features = this.features_ || new _Collection["default"]([this.lastFeature_]);
      this.dispatchEvent(new TranslateEvent(TranslateEventType.TRANSLATEEND, features, event.coordinate, this.startCoordinate_, event)); // cleanup

      this.startCoordinate_ = null;
      return true;
    }

    return false;
  };
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */


  Translate.prototype.handleDragEvent = function (event) {
    if (this.lastCoordinate_) {
      var newCoordinate = event.coordinate;
      var deltaX_1 = newCoordinate[0] - this.lastCoordinate_[0];
      var deltaY_1 = newCoordinate[1] - this.lastCoordinate_[1];
      var features = this.features_ || new _Collection["default"]([this.lastFeature_]);
      features.forEach(function (feature) {
        var geom = feature.getGeometry();
        geom.translate(deltaX_1, deltaY_1);
        feature.setGeometry(geom);
      });
      this.lastCoordinate_ = newCoordinate;
      this.dispatchEvent(new TranslateEvent(TranslateEventType.TRANSLATING, features, newCoordinate, this.startCoordinate_, event));
    }
  };
  /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */


  Translate.prototype.handleMoveEvent = function (event) {
    var elem = event.map.getViewport(); // Change the cursor to grab/grabbing if hovering any of the features managed
    // by the interaction

    if (this.featuresAtPixel_(event.pixel, event.map)) {
      elem.classList.remove(this.lastCoordinate_ ? 'ol-grab' : 'ol-grabbing');
      elem.classList.add(this.lastCoordinate_ ? 'ol-grabbing' : 'ol-grab');
    } else {
      elem.classList.remove('ol-grab', 'ol-grabbing');
    }
  };
  /**
   * Tests to see if the given coordinates intersects any of our selected
   * features.
   * @param {import("../pixel.js").Pixel} pixel Pixel coordinate to test for intersection.
   * @param {import("../PluggableMap.js").default} map Map to test the intersection on.
   * @return {import("../Feature.js").default} Returns the feature found at the specified pixel
   * coordinates.
   * @private
   */


  Translate.prototype.featuresAtPixel_ = function (pixel, map) {
    return map.forEachFeatureAtPixel(pixel, function (feature, layer) {
      if (this.filter_(feature, layer)) {
        if (!this.features_ || (0, _array.includes)(this.features_.getArray(), feature)) {
          return feature;
        }
      }
    }.bind(this), {
      layerFilter: this.layerFilter_,
      hitTolerance: this.hitTolerance_
    });
  };
  /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */


  Translate.prototype.getHitTolerance = function () {
    return this.hitTolerance_;
  };
  /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */


  Translate.prototype.setHitTolerance = function (hitTolerance) {
    this.hitTolerance_ = hitTolerance;
  };
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   */


  Translate.prototype.setMap = function (map) {
    var oldMap = this.getMap();

    _super.prototype.setMap.call(this, map);

    this.updateState_(oldMap);
  };
  /**
   * @private
   */


  Translate.prototype.handleActiveChanged_ = function () {
    this.updateState_(null);
  };
  /**
   * @param {import("../PluggableMap.js").default} oldMap Old map.
   * @private
   */


  Translate.prototype.updateState_ = function (oldMap) {
    var map = this.getMap();
    var active = this.getActive();

    if (!map || !active) {
      map = map || oldMap;

      if (map) {
        var elem = map.getViewport();
        elem.classList.remove('ol-grab', 'ol-grabbing');
      }
    }
  };

  return Translate;
}(_Pointer["default"]);

var _default = Translate;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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